{
  "version": 1,
  "asset_id": "999743d7-3731-4e63-8b2e-5ad29c02aa99",
  "project_id": "530287cc-6277-4c3a-8f0e-1235af941c4b",
  "url": "/__l5e/assets-v1/999743d7-3731-4e63-8b2e-5ad29c02aa99/logo2024.webp",
  "r2_key": "a/v1/530287cc-6277-4c3a-8f0e-1235af941c4b/999743d7-3731-4e63-8b2e-5ad29c02aa99/logo2024.webp",
  "original_filename": "logo2024.webp",
  "size": 2700,
  "content_type": "image/webp",
  "created_at": "2026-06-22T07:03:42Z"
}
